import { createRootStore } from 'libx';

import AppStore from 'stores/AppStore';
import QueryParamsStore from 'stores/QueryParamsStore';
import TnvedCodeStore from 'stores/TnvedCodeStore';
import GngCodeStore from 'stores/GngCodeStore';
import EtsngCodeStore from 'stores/EtsngCodeStore';
import CountryStore from 'stores/CountryStore';

const rootStore = createRootStore({
  queryParamsStore: QueryParamsStore,
  appStore: AppStore,
  tnvedCodeStore: TnvedCodeStore,
  gngCodeStore: GngCodeStore,
  etsngCodeStore: EtsngCodeStore,
  countryStore: CountryStore,
});

export default rootStore;



// WEBPACK FOOTER //
// ./src/stores/RootStore.js